import classNames from 'classnames'
import React, { useState, useEffect } from 'react'

function randomizeMole() {
  const moles = ['nellie', 'sofia', 'kotte', 'adam', 'nisse']
  const activeIndex = Math.ceil(Math.random() * moles.length) - 1

  return moles[activeIndex]
}

function MoleHole({ context, holeNumber, onClick, currentMole }) {
  const [savedMole, setSavedMole] = useState(randomizeMole())

  useEffect(() => {
    if (currentMole === holeNumber) {
      let newMole

      do {
        newMole = randomizeMole()
      } while (newMole === savedMole)

      setSavedMole(newMole)
    }
  }, [currentMole, holeNumber])

  useEffect(() => {
    console.log(savedMole)
  }, [savedMole])

  return (
    <div className="game__hole" style={{ display: context.display }}>
      <div className="game__whack">
        <div
          className={classNames(['game__mole', `is-${savedMole}`])}
          onClick={onClick}
          style={{ WebkitTransform: context[holeNumber] }}
        ></div>
        <div className={classNames(['game__mound', `is-${holeNumber}`])}></div>
      </div>
    </div>
  )
}

export default MoleHole



// WEBPACK FOOTER //
// ./src/components/MoleHole.js